/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
export const inaxConfigUiTranslations: any = {
  "en-GB": {
    "inax-config" : {
      "settings" : "INAX Configuration",
      "url" : "Service URL",
      "username": "Username",
      "password" : "Password",
      "defaultLanguage" : "Default Language",
      "useSignalR": "Use SignalR",
      "apply": "Apply"
    }
  },
  "de-DE": {
    "inax-config" : {
      "settings" : "INAX Konfiguration",
      "url" : "Service URL",
      "username": "Benutzername",
      "password" : "Passwort",
      "defaultLanguage" : "Standardsprache",
      "useSignalR": "SignalR verwenden",
      "apply": "Übernehmen"
    }
  }
};